import axios from 'axios';
import router from '../router/index.js'; 
import qs from 'qs';

const baseURL = 'http://localhost:5135/';

// 配置axios
const axiosOption = {
  timeout: 1000 * 30,
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
};

// 创建axios
const instance = axios.create(axiosOption);
// 添加请求拦截器
instance.interceptors.response.use(
  response => {
    // 如果响应成功，直接返回响应数据
    return response;
  },
  error => {
    // 检查响应错误信息中的状态码
    if (error.response && error.response.status === 401) {
      // 如果状态码为401，表示token过期，跳转到登录页
      // window.location.href = '/login';
      router.push({ name: 'login' });
    }
    return Promise.reject(error);
  }
);

// 请求拦截器，转换为formData类型数据
// instance.interceptors.request.use(
//   (config) => {
//     if (config.method === 'post') {
//       config.data = qs.stringify(config.data);
//     }
//     // const {
//     //   language
//     // } = store.state.userSetting;
//     // config.headers['Accept-Language'] = 'cn';
//     return config;
//   },
//   // eslint-disable-next-line
//   (error) => Promise.error(error)
// );

// 请求拦截
export default instance;